var _g, _rect, _rect2, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#BF5B37",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 60,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 60,
    height: 60,
    transform: "rotate(45 60 60)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 40,
    height: 40,
    rx: 8,
    ry: 8,
    fill: "#BF5B37"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 44,
    width: 32,
    height: 32,
    rx: 4,
    ry: 4,
    fill: "#BF5B37"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "44,52 60,66 76,52",
    fill: "none",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeEmail);
export default __webpack_public_path__ + "static/media/icone-email.0cd45594f9682a7514aa65f71360a24d.svg";
export { ForwardRef as ReactComponent };